import { useQuery, type UseQueryResult } from "@tanstack/react-query";
import type { IAPI } from "../APIService";
import type { AxiosResponse } from "axios";
import { buildQueryKey } from "@/utils/query";
import { EndpointService } from "@/types/api/api";

export interface IAllergen {
  id: number;
  name: string;
  order: number;
}

export interface IDietaryRequirement {
  id: number;
  name: string;
  order: number;
}

export interface IContextService {
  listAllergens: () => UseQueryResult<IAllergen[], Error>;
  listDietaryRequirements: () => UseQueryResult<IDietaryRequirement[], Error>;
}

export class ContextService implements IContextService {
  api: IAPI;

  constructor(api) {
    this.api = api;
  }

  listAllergens(): UseQueryResult<IAllergen[], Error> {
    return useQuery({
      queryKey: buildQueryKey({
        queryKey: ["operations", "context", "allergens"],
        venueID: this.api.selectedVenue,
        params: {},
      }),
      queryFn: async () => {
        const { data } = await this.api.get<AxiosResponse<IAllergen[]>>(
          "/menu/allergens/",
          {
            endpointService: EndpointService.Core,
            venueSpecific: false,
            params: {},
          },
        );
        return data;
      },
    });
  }

  listDietaryRequirements(): UseQueryResult<IDietaryRequirement[], Error> {
    return useQuery({
      queryKey: buildQueryKey({
        queryKey: ["operations", "context", "dietary-requirements"],
        venueID: this.api.selectedVenue,
        params: {},
      }),
      queryFn: async () => {
        const { data } = await this.api.get<
          AxiosResponse<IDietaryRequirement[]>
        >("/menu/dietary_requirements/", {
          endpointService: EndpointService.Core,
          venueSpecific: false,
          params: {},
        });
        return data;
      },
    });
  }
}
